export default "__VITE_ASSET__bacb0b75__"